import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Loader } from '../common'
import { TreeView } from './component'
class CategoryComponent1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			apiDef: null,
			loading: true,
			items: [],
			hierarchy: {},
			fieldsMeta: null,
			itemData: [],
			error: null,
		}
	}
	componentWillMount() {
		const {
			meta: { appComponentMeta },
		} = this.props
		appComponentMeta &&
			appComponentMeta.staticContent &&
			appComponentMeta.staticContent.content &&
			this.setState({ apiDef: appComponentMeta.staticContent.content })
		this.apiRequest()
	}

	apiRequest = async () => {
		let { t } = this.props
		this.props.getAll({ filter: [{ name: 'status', value: 'Published' }], top: 500, t })
		this.props.getRefItems({
			apiDef: { path: 'ticketing/CategoryHierarchy', entityName: 'CategoryHierarchy' },
			filter: [{ name: 'status', value: 'Published' }],
			t,
		})
	}
	async componentWillReceiveProps(nextProps) {
		const { itemData } = this.state
		let data = []
		let hierarchy = {}
		if (nextProps && nextProps.entityList && nextProps.entityList.itemData && nextProps.entityList.itemData) data = nextProps.entityList.itemData

		if (nextProps && nextProps.entity && nextProps.entity.refEntityList && nextProps.entity.refEntityList.CategoryHierarchy)
			hierarchy = nextProps.entity.refEntityList.CategoryHierarchy

		if (nextProps && nextProps.entity && nextProps.entity.entityValues && typeof nextProps.entity.entityValues === 'object')
			data = [...itemData, ...data, nextProps.entity.entityValues]

		let items = await this.nodeTree(data)
		this.setState({
			items,
			itemData: data,
			hierarchy,
			count: nextProps.entityList.count,
			loading: nextProps.entityList.loading,
		})
	}
	nodeTree(items) {
		let arr = items.map(a => ({ ...a }))
		var tree = [],
			mappedArr = {},
			arrElem,
			mappedElem

		for (var i = 0, len = arr.length; i < len; i++) {
			arr[i].key = arr[i].id
			arr[i].title = arr[i].label
			arrElem = arr[i]
			mappedArr[arrElem.id || arrElem.name] = arrElem
			mappedArr[arrElem.id || arrElem.name]['children'] = []
		}

		for (var parentName in mappedArr) {
			if (mappedArr.hasOwnProperty(parentName)) {
				mappedElem = mappedArr[parentName]

				if (mappedElem.parentName) {
					let parentElm = items.find(item => item.name === mappedElem.parentName)
					mappedArr[parentElm?.id] && mappedArr[parentElm?.id]['children'].push(mappedElem)
					// mappedArr[mappedElem['parentName']] && mappedArr[mappedElem['parentName']]['children'].push(mappedElem)
				} else {
					tree.push(mappedElem)
				}
			}
		}
		return tree
	}

	createAddModal(item, level) {
		const { meta } = this.props
		if (meta && meta.contentMeta && meta.contentMeta.addModal) {
			let addModal = meta.contentMeta.addModal
			addModal.level = level
			addModal.parentName = level && level > 1 && item ? item.name || level.label : null
			return addModal
		} else {
			return false
		}
	}
	validateItem(data) {
		const { t } = this.props
		const { itemData } = this.state
		let dataVal = Object.assign({}, data)
		if (dataVal && itemData && itemData.length > 0) {
			let findExisting = itemData.find(x => x?.name?.toLowerCase() === dataVal?.name?.toLowerCase() && x?.parentName?.toLowerCase()==dataVal?.parentName?.toLowerCase())
			let findExistingLabel = itemData.find(x => x?.label?.toLowerCase() === dataVal?.label?.toLowerCase() && x?.parentName?.toLowerCase()==dataVal?.parentName?.toLowerCase())
			if (findExisting && findExisting.name  && !dataVal.id) {
				if ((findExisting.level === dataVal.level && findExisting.parentName === dataVal.parentName) && findExisting?.label?.toLowerCase()===dataVal?.label?.toLowerCase()) {
					this.setState({ error: t('Record already exists!') })
					dataVal.name = null
				} else if(findExisting.level === 1 && findExisting.parentName === null && findExisting?.label?.toLowerCase()===dataVal?.label?.toLowerCase()) {
					this.setState({ error: t('Record already exists!') })
					dataVal.name = null
				}else {
					dataVal.name = `${dataVal.parentName || ''}_${dataVal.name}`
				}
			} 
			else if (findExistingLabel && findExistingLabel.name && !dataVal.id) {
				if ((findExistingLabel.level === dataVal.level && findExistingLabel?.label?.toLowerCase() === dataVal?.label?.toLowerCase() && findExistingLabel.parentName === dataVal.parentName)) {
					this.setState({ error: t('Record already exists!') })
					dataVal.name = null
				}
			}
			else if (findExistingLabel && findExistingLabel.name && dataVal.id) {
				if ((findExistingLabel.level === dataVal.level && findExistingLabel.label === dataVal.label && findExistingLabel.parentName === dataVal.parentName)) {
					this.setState({ error: t('Record already exists!') })
					dataVal.name = null
				}
			}
		}
		return dataVal
	}
	onSubmit(item) {
		const { itemData } = this.state
		let myItem = Object.assign({}, item)
		if (!myItem.name || myItem.name == '') myItem.name = myItem.label
		this.setState({ loading: true })
		let { t } = this.props
		let validItem = this.validateItem(myItem)

		if (validItem && validItem?.name !== null) {
			this.setState({ error: null })
			setTimeout(() => {
				this.props.upsertItem({ entityValues: validItem, itemType: 'default', t })
			}, 200)
		} else {
			this.setState({ loading: false })
		}
	}

	onDelete(item) {
		item.status = 'Deleted'
		let { t } = this.props

		this.setState({ loading: true })
		setTimeout(() => {
			this.props.upsertItem({ entityValues: item, t })
		}, 500)
	}

	render() {
		const { t } = this.props
		const { items, hierarchy, itemData, loading, error } = this.state
		return (
			<div className="animated fadeIn">
				{loading && <Loader />}
				<div className="main-section" style={{marginTop:'10px'}}>
					<div className="main-inner1" style={{
	background: '#fff',
    borderRadius: '5px',
    padding: '16px',
    boxShadow: '0 0 14px 4px rgba(159, 179, 193, 0.12)',
    paddingTop: '0px'
}}>
						<div className="common-heading">
							<div className="row table-title">
								<div className="col-sm-12">
									<div className="heading" style={{padding:'5px',marginTop:'18px'}}>
										<h5>{t('Category')}</h5>
									</div>
								</div>
							</div>
							{error && <span className="text-danger">{error}</span>}
						</div>
						<section>
							<div className="row">
								{items && (
									<TreeView
										treeData={items}
										levelLabels={hierarchy && hierarchy.properties ? hierarchy.properties : []}
										itemData={itemData}
										meta={this.props.meta}
										createAddModal={this.createAddModal.bind(this)}
										onSubmit={this.onSubmit.bind(this)}
										onDelete={this.onDelete.bind(this)}
									/>
								)}
							</div>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

export const CategoryComponent = withTranslation()(CategoryComponent1)
